import React from "react";

export default function Impressum() {
  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-12 py-16 sm:py-20" data-testid="impressum-page">
      <div className="text-xs uppercase tracking-[0.3em] text-terracotta mb-4">— Rechtliches</div>
      <h1 className="font-display text-4xl sm:text-5xl text-ink leading-tight">Impressum</h1>

      <div className="mt-10 space-y-8 text-ink leading-relaxed text-[15px]">
        <section>
          <h2 className="font-display text-2xl mb-3">Anbieter</h2>
          <p>
            <strong>Regula Müller – Ayurveda Aargau</strong><br />
            Massage für Frauen
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl mb-3">Standorte</h2>
          <p>
            <strong>Sarmenstorf</strong><br />
            Obere Feldeggstr. 13<br />
            5614 Sarmenstorf
          </p>
          <p className="mt-4">
            <strong>Rupperswil</strong><br />
            Aarestrasse 20<br />
            5102 Rupperswil
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl mb-3">Kontakt</h2>
          <p>
            E-Mail Buchungen:{" "}
            <a href="mailto:contact@ayurveda-aargau.ch" className="text-terracotta hover:underline">
              contact@ayurveda-aargau.ch
            </a>
            <br />
            E-Mail Allgemein:{" "}
            <a href="mailto:info@ayurveda-aargau.ch" className="text-terracotta hover:underline">
              info@ayurveda-aargau.ch
            </a>
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl mb-3">Haftungsausschluss</h2>
          <p>
            Die Inhalte dieser Webseite werden mit grösster Sorgfalt erstellt. Für die
            Richtigkeit, Vollständigkeit und Aktualität der Inhalte kann jedoch keine
            Gewähr übernommen werden. Die Inhalte ersetzen keine medizinische Beratung.
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl mb-3">Urheberrecht</h2>
          <p>
            Sämtliche Inhalte dieser Webseite (Texte, Bilder, Grafiken) sind urheberrechtlich
            geschützt. Eine Vervielfältigung, Bearbeitung oder Veröffentlichung – auch
            auszugsweise – bedarf der vorherigen schriftlichen Zustimmung der Anbieterin.
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl mb-3">Externe Links</h2>
          <p>
            Diese Webseite enthält Links zu externen Webseiten. Für die Inhalte dieser
            externen Seiten ist ausschliesslich der jeweilige Betreiber verantwortlich.
          </p>
        </section>
      </div>
    </div>
  );
}
